import React, { ReactNode } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AuthLeftPanel from '../Common/AuthLeftPanel';
import { useFormik } from 'formik';
import { forgotPasswordInitialValues, forgotPasswordSchema } from 'constants/schemaValidations';
import { ForgotPasswordInterface } from 'constants/interfaces';
import { useForgotPasswordMutation } from 'services';
import { USER_TYPES } from 'constants';
import toast from 'react-hot-toast';
import BackBtn from 'components/Common/BackBtn';
import useTranslate from 'hooks/useTranslate';

const ForgotPassword: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { mutateAsync: forgotPasswordMutation } = useForgotPasswordMutation();
	const [searchParams] = useSearchParams();
	const userType = searchParams.get('userType');

	const formik = useFormik({
		initialValues: { ...forgotPasswordInitialValues },
		validationSchema: forgotPasswordSchema(translate),
		onSubmit: async (values) => {
			forgotPasswordMutation({ ...values, userType: USER_TYPES.SEEKER })
				.then((res: any) => {
					if (res?.success) {
						toast.success(res?.message);
						navigate(`/verify-otp?userType=${userType || USER_TYPES.SEEKER}&email=${values.email}`);
					}
				})
				.catch((err: any) => {});
		},
	});

	const renderError = <T extends keyof ForgotPasswordInterface>(field: T) =>
		formik.touched[field] && formik.errors[field] ? (
			<span className="text-danger f-error">{formik.errors[field] as ReactNode}</span>
		) : null;

	return (
		<div className="auth bg-white d-flex flex-column flex-lg-row">
			<div className="auth-left-content">
				<AuthLeftPanel />
			</div>
			<div className="auth-right-content flex-1 d-flex align-items-center justify-content-center position-relative">
				<BackBtn />
				<div className="auth-form mb-0 mt-5 mx-3 my-5 m-md-5">
					<div className="auth-form-heading text-center">
						<h2 className="mb-3">
							{translate('Common.forgot')}{' '}
							<span className="fw-bold">{translate('PlaceHolder.password')}!</span>
						</h2>
						<p className="mb-0">{translate('Auth.authHeadingForgotPassword')}</p>
					</div>
					<div className="auth-form-fields">
						<Form className="form" onSubmit={formik.handleSubmit}>
							<Form.Group className="mb-4 position-relative">
								<Form.Label className="lh-1">{translate('PlaceHolder.email')}</Form.Label>
								<Form.Control
									type="email"
									placeholder={translate('PlaceHolder.emailText1')}
									name="email"
									className="rounded-pill"
									onChange={formik.handleChange}
									onBlur={formik.handleBlur}
									value={formik.values.email}
									autoComplete="off"
								/>
								{renderError('email')}
							</Form.Group>
							<div className="form-btn">
								<Button className="filled-btn rounded-pill w-100" type="submit">
									{translate('Common.submit')}
								</Button>
							</div>
						</Form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
